import {useEffect, useState} from "react";
import * as XLSX from 'xlsx';
import {DefaultFileUpload} from "../file/DefaultFileUpload.tsx";
import {HelpUtil} from "@/util/HelpUtil.ts";
import {useDispatch, useSelector} from "react-redux";
import {TailSpin} from "react-loader-spinner";
import {AppDispatch, RootState} from "@/store";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {CreateBulkEntityRequest} from "@/model/request/entity/CreateBulkEntityRequest.ts";
import {ModalType} from "./NewApplicationModal.tsx";
import {entity} from "@/store/modules/entity.ts";


function EntityBulkUploadModal({show, onClose}: ModalType) {
    const [fileName, setFileName] = useState("");
    const [fileData, setFileData] = useState<CreateBulkEntityRequest>([]);
    const entityState = useSelector((state: RootState) => state.entity);
    const applicationState = useSelector((state: RootState) => state.application);
    const dispatch = useDispatch<AppDispatch>()

    const fileUrl = "/file/entityTemplate.xlsx";
    //
    // const handleDownload = () => {
    //     const link = document.createElement('a');
    //     link.href = fileUrl;
    //     // link.target = '_blank';  // Opens in a new tab
    //     link.rel = 'noopener noreferrer'; // Security measure
    //     document.body.appendChild(link);  // Append to the DOM
    //     link.click();
    //     document.body.removeChild(link);  // Clean up
    // };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "template.xlsx";
        link.target = "_blank"
        link.click();
        link.remove();
    };


    const onExcelUpload = (file: any) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const result = e.target?.result;
            let data
            if (result) {
                data = new Uint8Array(result as ArrayBuffer);
                // console.log(data);
            } else {
                console.error("File read error");
            }
            const workbook = XLSX.read(data, {type: 'array'});
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet) as unknown as CreateBulkEntityRequest;
            console.log(json)
            setFileData(json)
            // action && action(json)
            // setPreview(null)
            // HelpUtil.modalFunction(ModalConstant.importModal).close()
        };
        reader.readAsArrayBuffer(file);
    };

    const onCsvUpload = (file: any) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target?.result
            const data = HelpUtil.parseCSV(text) as unknown as CreateBulkEntityRequest;
            console.log(data)
            setFileData(data)
            // action && action(data)
            // setPreview(null)
            // HelpUtil.modalFunction(ModalConstant.importModal).close()
        };
        reader.readAsText(file);
    };
    useEffect(() => {
        setFileName("")
    }, [show]);

    const showMessage = (
        response: any,
        title: "error" | "Success" = "Success",
        type: "error" | "success" = "success"
    ) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: type,
                        title: title,
                        body: response.responseMessage,
                    })
                )
                dispatch(entity.action.readByEntityApplicationId({entityApplicationId: applicationState.selectedApplication?.applicationId}))
            }
        );
        onClose()
    };

    function handleOnSubmit() {
        const updatedFileData = fileData.map(it => ({
            ...it,
            entityApplicationId: applicationState.selectedApplication?.applicationId ? applicationState.selectedApplication?.applicationId : 0
        }))
        dispatch(entity.action.bulkCreate(updatedFileData)).then((result: any) => {
            if (result.payload.responseCode == "00") {
                showMessage(result.payload, "Success", "success")
            } else {
                showMessage(result.payload, "error", "error")
            }
        })
        console.log(updatedFileData)
    }

    // const handleOnSubmit = () => {
    //     dispatch(entity.action.bulkCreate({
    //         data: updatedFileData,
    //         onSuccess: (response: any) => showMessage(response, "Success", "success"),
    //         onError: (response: any) => showMessage(response, "error", "error")
    //     }))
    // }

    const handleOnChange = (value: File) => {
        console.log(value.name)
        if (value.name?.includes('.csv')) {
            setFileName(value.name);
            onCsvUpload(value)
        } else {
            setFileName(value.name);
            onExcelUpload(value)
        }
    }

    // const handleDownloadTemplate = () => {
    //     const templateUrl = "./public/FirsDesignTemplate.xlsx";
    //     window.location.href = templateUrl;
    // };
    return (
        <>
            {show &&
                <div className="modal1_component">
                    <div className="modal1_content-wrapper modal1_background-overlay">
                        <div className="bulk-modal">
                            <div className="modal-head ">
                                <h5>Upload File</h5>
                                <i className=" text-4xl bx bx-x" onClick={onClose}></i>
                            </div>
                            <div className="download">
                                <i className="bx bx-download text-orange-500 text-xl"></i>
                                <span className="underline text-orange-500 cursor-pointer"
                                      onClick={handleDownload}>Download Template</span>
                            </div>

                            <DefaultFileUpload types={['xlsx', 'csv']} onChangeFile={handleOnChange}>
                                <div className={""}>
                                    <p className=" text-xl font-bold">
                                        Select a CSV OR XLSX file to upload
                                    </p>
                                    <p className="text-gray-800">or drag and drop it here</p>
                                    {fileName && (
                                        <p><span className={"font-bold"}>Selected file: </span>{fileName}</p>
                                    )}
                                </div>
                            </DefaultFileUpload>
                            <div className={"flex gap-3 justify-end"}>
                                <button className="button" onClick={handleOnSubmit} disabled={fileData.length == 0}>
                                    {entityState.loading ?
                                        <p style={{margin: "auto", marginTop: "15px"}}>
                                            <TailSpin visible={true} height={20} width={20} color="#ec9c3f"
                                                      ariaLabel="tail-spin-loading" strokeWidth={5}
                                                      wrapperStyle={{}}
                                                      wrapperClass=""
                                            />
                                        </p> : "Upload"
                                    }
                                </button>
                                <button className="button is-secondary" onClick={onClose}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>

    );
}

export default EntityBulkUploadModal;
